import 'owl.carousel';

jQuery( document ).ready(function($) {
    $('#video-carousel').owlCarousel({
        loop:true,
        items: 2,
        margin: 20,
        dots: false, 
        nav: true,
        navText: [
          "<i class='fas fa-chevron-left'></i><span class='sr-only'>Prev</span>",
          "<i class='fas fa-chevron-right'></i><span class='sr-only'>Next</span>"
        ],
    });

    $("#video-carousel .item a").on("click", function(e) {
        e.preventDefault();
        var id = $(this).attr("data-id");
        $("#videos iframe").attr(
            "src",
            "https://www.youtube.com/embed/" + id + "/?autoplay=1"
        );
        $(".main-video-title").text($(this).attr("data-title"));
    });

    
    $.ajax({
        url: 'https://www.juicer.io/api/feeds/kevinolusola',
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            console.log(data);
            let c = 1;
            let cT = 1;
            let htmlT = '';
            let html = '';
            for (let item of data.posts.items) {
                const img = item.image;
                if (item.full_url.includes('tiktok')){
                    if (cT < 4){
                        htmlT += `
                        <div>
                            <a href="${item.full_url}" target="_blank" style="background-image: url('${img}');" aria-label="Instagram Post">
                            </a>
                        </div>
                        `;
                        cT++
                    }
                } else {
                    if (c < 9){
                        html += `
                        <div>
                            <a href="${item.full_url}" target="_blank" style="background-image: url('${img}');" aria-label="TikTok Video">
                            </a>
                        </div>
                        `;
                        c++;
                    }
                }
            }
            $('#feed').html(html);
            $('#feedT').html(htmlT);
        },
        error: function () {
            console.log('Error loading feed.');
        }
    });
});